<template>
  <div class="navbar-right__mobileAction d-md-none" style="left: 0px">
    <v-app-bar-nav-icon
      class="mobile-menu"
      variant="text"
      @click.stop="drawer = !drawer"
    ></v-app-bar-nav-icon>

    <v-navigation-drawer v-model="drawer" temporary class="p-0" style="overflow:hidden">
      <v-list class="p-0">
        <template v-for="(headerMenuItem, index) in HeaderMenuItems" :key="index">
          <mobile-menu-child-item
            v-if="!headerMenuItem.submenu"
            class="p-0"
            :menu="headerMenuItem"
            :menuId="index"
          />
          <mobile-menu-parent-group
            v-else
            class="p-0"
            :menu="headerMenuItem"
            :menuId="index"
          />
        </template>
        <v-btn @click.prevent="logoutUser" variant="text">
          <v-icon left>mdi-logout</v-icon>
          Logout
        </v-btn>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import MobileMenuChildItem from "@/components/mobile_menu/MobileMenuChildItem.vue";
import MobileMenuParentGroup from "@/components/mobile_menu/MobileMenuParentGroup.vue";
import common from "@/Common.vue";

export default {
  components: {
    MobileMenuChildItem,
    MobileMenuParentGroup,
  },
  mixins: [common],

  data: () => ({
    drawer: false,
    HeaderMenuItems: [],
  }),

  methods: {
    refreshPageData() {
      console.log("Refreshing page data...");
      const selectbox1_source = "HeaderMenu";
      const selectbox1_destination = "HeaderMenuItems";
      const selectbox1_url = "api/jcom-web/user-menu";
      const selectbox1_conditions_array = { UserInterface: 1 };

      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
  },

  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 960px) and (max-width: 1080px) {
  .mobile-menu {
    visibility: visible;
  }
}

@media only screen and (min-width: 960px) {
  .d-md-none {
    display: none;
  }
}
</style>
